import { uniqueOptions } from '@features/Attachments/utils/filterOptions';
/** Category options come only from what's present — there is no "all categories" endpoint in scope here. */
export function buildCategoryOptions(rows) {
    return uniqueOptions(rows, (row) => row.categoryFilterValue, (row) => row.categoryLabel);
}
/**
 * Category options for the inline-edit `Category` cell (`InlineSelect`), plus the `null` "No
 * category" sentinel the legacy form always includes (`include_blank`, `new.html.erb:32`).
 *
 * The facade is the intended long-term source — the legacy view pulls the full tenant category
 * list via `AttachmentCategory.pluck(:name, :id)`, not just categories currently in use. Until that
 * facade prop is threaded through, this derives the same shape from what's already fetched (the
 * categories actually present on this building's rows) as a sensible default; the feature's
 * `categoryOptions` prop lets a caller override it with the real tenant-wide list.
 */
export function buildCategoryEditOptions(rows, translateFn) {
    const seen = new Map();
    rows.forEach((row) => {
        if (row.categoryId != null && !seen.has(row.categoryId))
            seen.set(row.categoryId, row.categoryLabel);
    });
    const categories = Array.from(seen.entries())
        .map(([id, label]) => ({ id, label }))
        .sort((a, b) => a.label.localeCompare(b.label));
    return [{ id: null, label: translateFn('no_category') }, ...categories];
}
/** Visibility options are fixed (not data-derived) — see the design's three-option enumeration. */
export function buildVisibilityOptions(translateFn) {
    return [
        { value: 'techs', label: translateFn('visibility_options.techs') },
        { value: 'hidden', label: translateFn('visibility_options.hidden') },
        { value: 'portal', label: translateFn('visibility_options.portal') }
    ];
}
